import { DEX_TYPE } from '@/config/constants'
import { getEnvAndDex } from '@/utils/getEnvAndDex'

export const useTradex = () => {
  const { dex } = getEnvAndDex()
  return dex === DEX_TYPE.SGTRADEX
}
